export const SEARCH_PLACEHOLDER = "Search Artisanal Treasures..";
